import { useEffect, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { RightIcon } from 'foundations-assets';
import { View } from 'foundations-components/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import CompanionFooter from './CompanionFooter';
import QuizMeLoading from './QuizMeLoading';
import QuizMeQuestions from './QuizMeQuestions';
import UsageTracker from '../../../utils/UsageTracker';
import { useMockedQuizMeQuery, useQuizMeSession } from '../utils/quizMeUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const QuizMeTab = ({
  contentId,
  contentType
}) => {
  const [questionAnswered, setQuestionAnswered] = useState(false);
  const [selectedAnswerIndex, setSelectedAnswerIndex] = useState();
  const [selectedAnswerCorrect, setSelectedAnswerCorrect] = useState();
  const {
    incrementQuestionWithAnswer,
    initialiseQuiz
  } = useQuizMeSession();
  useEffect(() => {
    UsageTracker.track('interaction', {
      action: 'ai-quiz-me-rendered',
      id: contentId,
      contentType
    });
  }, [contentId, contentType]);
  const {
    data,
    loading
  } = useMockedQuizMeQuery({
    contentType,
    contentId
  });
  const handleSelectAnswerIndexChange = (answerIndex, correct) => {
    setSelectedAnswerIndex(answerIndex);
    setSelectedAnswerCorrect(correct);
  };
  const handleCheckAnswer = () => {
    UsageTracker.track('contentProgress', {
      action: 'ai-quiz-me-answered-question',
      contentId,
      contentType
    });
    incrementQuestionWithAnswer({
      contentType,
      contentId,
      correct: !!selectedAnswerCorrect
    });
    setQuestionAnswered(true);
  };
  const handleNext = () => {
    setQuestionAnswered(false);
    setSelectedAnswerIndex(undefined);
    setSelectedAnswerCorrect(undefined);
  };
  const handleRetakeQuiz = () => {
    UsageTracker.track('contentInteraction', {
      action: 'ai-quiz-me-retake',
      contentId,
      contentType
    });
    initialiseQuiz({
      contentType,
      contentId
    });
    setQuestionAnswered(false);
    setSelectedAnswerIndex(undefined);
    setSelectedAnswerCorrect(undefined);
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(View, {
      paddingBlockStart: "700",
      paddingInline: "700",
      children: loading || !(data !== null && data !== void 0 && data.quiz) ? /*#__PURE__*/_jsx(QuizMeLoading, {}) : /*#__PURE__*/_jsx(QuizMeQuestions, {
        contentId: contentId,
        contentType: contentType,
        handleRestartQuiz: handleRetakeQuiz,
        handleSelectAnswerIndexChange: handleSelectAnswerIndexChange,
        questionAnswered: questionAnswered,
        quizQuestions: data.quiz,
        selectedAnswerIndex: selectedAnswerIndex
      })
    }), /*#__PURE__*/_jsx(CompanionFooter, {
      additionalButtons: /*#__PURE__*/_jsxs(ButtonWrapper, {
        children: [!questionAnswered && selectedAnswerIndex !== undefined && /*#__PURE__*/_jsxs(Button, {
          onClick: handleCheckAnswer,
          use: "tertiary",
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.interactiveEducation.quiz.checkAnswer"
          }), /*#__PURE__*/_jsx(RightIcon, {})]
        }), questionAnswered && /*#__PURE__*/_jsxs(Button, {
          onClick: handleNext,
          use: "tertiary",
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.interactiveEducation.quiz.next"
          }), /*#__PURE__*/_jsx(RightIcon, {})]
        })]
      }),
      contentId: contentId,
      contentType: contentType
    })]
  });
};
export default QuizMeTab;